<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'vehicleCrud'"
            :crudName="$t('Vehicles')"
            :newText="$t('Add')+ '  '+$t('New')"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="true"
            :enableReset="false" :dataForm="dataForm">
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data() {
    return {
      table: "vehicleTable",
      showMessageImport: false,
      vehicleCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "license_plate",
        "tracking_token",
        "status",
        "unit_id",
        "center_id",
        "actions",
      ],
      tableData: ["id", "name", 'license_plate', 'tracking_token','status', 'unit_id', 'center_id'],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "license_plate", "tracking_token",'status', 'unit_id', 'center_id'],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('id'),
          name: this.$t('Assignment'),
          license_plate: this.$t('License Plate'),
          tracking_token: this.$t('Tracking Token'),
          status: this.$t('Status'),
          unit_id: this.$t('Unit'),
          center_id: this.$t('Center'),
          actions: this.$t('action'),
        },

        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        listColumns: {
          status: [
            {id: 1, text: this.$t('Active')},
            {id: 0, text: this.$t('Inactive')}
          ]
        },
        templates: {
          status: function (h, row, index) {
            return row.status == 1 ?
                this.$t('Active') :
                this.$t('Inactive')
          },
          center_id: function (h, row, index) {
            return row.center?.name ?? ''
          },
          unit_id: function (h, row, index) {
            return row.unit?.name ?? ''
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["center", "unit"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "vehicles",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('id'),
        name: this.$t('Assignment'),
        license_plate: this.$t('License Plate'),
        level: this.$t('Situation'),
        tracking_token: this.$t('Tracking Token'),
        status: this.$t('Status'),
        unit_id: this.$t('Unit'),
        center_id: this.$t('Center'),
        actions: this.$t('action'),
      };

      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      };

      return {
        ...this.optionsOrigin,
        texts,
        headings,
      };
    },
  },
  mounted() {
    const self = this;

    this._axiosInterceptor = axios.interceptors.response.use(
        (response) => {
          try {
            const config = response.config || {};
            const method = (config.method || '').toLowerCase();
            const url = config.url || '';

            if (method === 'delete' && url.indexOf(self.endPoint) !== -1) {
              let msg;
              if (typeof response.data === 'string') msg = response.data;
              else if (response.data && response.data.message) msg = response.data.message;
              else msg = self.$t('Registro removido com sucesso') || 'Registro removido com sucesso';
              if (self.$message) self.$message(self.$t('success') || 'Success', msg, 'success');
              self.$nextTick(() => {
                try {
                  if (self.$refs.vehicleCrud && self.$refs.vehicleCrud.$refs && self.$refs.vehicleCrud.$refs.table) {
                    self.$refs.vehicleCrud.$refs.table.refresh();
                  }
                } catch (e) {
                  console.error('Erro ao atualizar a grade:', e);
                }
              });
            }
          } catch (e) {
            console.error('Erro ao capturar resposta de DELETE:', e);
          }
          return response;
        },
        (error) => {
          try {
            const config = error.config || {};
            const method = (config.method || '').toLowerCase();
            const url = config.url || '';

            if (method === 'delete' && url.indexOf(self.endPoint) !== -1) {
              let msg;
              if (error.response && error.response.data) {
                if (typeof error.response.data === 'string') msg = error.response.data;
                else if (error.response.data.message) msg = error.response.data.message;
                else msg = JSON.stringify(error.response.data);
              } else msg = error.message || self.$t('server_error') || 'Server error';

              if (self.$message) self.$message(self.$t('Error') || 'Error', msg, 'error');
            }
          } catch (e) {
            console.error('Erro ao capturar resposta de DELETE:', e);
          }
          return Promise.reject(error);
        }
    );
  },
  beforeDestroy() {
    try {
      if (this._axiosInterceptor !== undefined) axios.interceptors.response.eject(this._axiosInterceptor);
    } catch (e) {
      console.error('Erro ao remover o interceptor:', e);
    }
  },
  methods: {
    makeFormData() {
      let fd = new FormData();

      let fileImport = document.getElementById('fileImport');

      fd.append('fileImport', fileImport && fileImport.files[0] ? fileImport.files[0] : '');

      return fd;
    },
    query(query) {
      let columns = {
        id: 'id',
        name: 'name',
        license_plate: 'license_plate',
        unit_id: 'unit[name]',
        center_id: 'center[name]',
        status: "status",
        tracking_token: 'tracking_token',
      };

      let filters = '';
      $.each(query, function (index, value) {
        filters += columns[index] + '=' + value + '&';
      });
      return filters;
    },
    openInput() {
      const el = document.getElementById('fileImport');
      if (el) el.click();
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
